import React from 'react';

const MoviesHeading = (props) => {
    return (
        <div className='col'>
            <h2>{props.head}</h2>
        </div>
    )
}

export default MoviesHeading;